import { Ban, CircleAlert, CircleCheck, Info, X } from "lucide-react"
import clsx from "classnames"
import { useTranslations } from "modules/i18n/hooks/useTranslations"
import { useState, useCallback } from "react"
import { NotificationProps } from "common/components/NotificationBar/types"

export const NotificationBar = ({ type, title, message, open }: NotificationProps) => {
  const t = useTranslations("components.notification_bar")

  const [visible, setVisible] = useState(open ?? true)
  const onClose = useCallback(() => setVisible(false), [setVisible])

  if (!visible) {
    return null
  }

  return (
    <section
      role="status"
      className={clsx("flex w-full flex-row items-center", {
        "bg-green-50 text-green-700": type === "success",
        "bg-yellow-50 text-yellow-700": type === "warning",
        "bg-red-50 text-red-600": type === "error",
        "bg-gray-50 text-gray-600": type === "info",
      })}
    >
      <div
        className={clsx("grow border-l-4 py-2 pr-2 pl-3", {
          "border-green-700": type === "success",
          "border-yellow-600": type === "warning",
          "border-red-600": type === "error",
          "border-gray-700": type === "info",
        })}
      >
        <div className="flex flex-row items-center gap-2">
          {type === "error" && <Ban className="size-5" />}
          {type === "warning" && <CircleAlert className="size-5" />}
          {type === "success" && <CircleCheck className="size-5" />}
          {type === "info" && <Info className="size-5" />}

          <div className="grow text-base font-bold">{title}</div>

          <button className="cursor-pointer" onClick={onClose} aria-label={t("close")}>
            <X className="size-5 font-bold" />
          </button>
        </div>

        {message && <p className="pl-7 text-xs">{message}</p>}
      </div>
    </section>
  )
}
